var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833333,
    y: 0.333333,
    width: 23.3333,
    height: 23.3333,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.833333,
    y: 0.333333,
    width: 23.3333,
    height: 23.3333,
    rx: 5,
    stroke: "#D0D5DD",
    strokeWidth: 0.666667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.611 6.44434C12.3837 6.44434 11.3888 7.43926 11.3888 8.66656V9.77767H9.16656C7.93926 9.77767 6.94434 10.7726 6.94434 11.9999V15.3332C6.94434 16.5605 7.93926 17.5554 9.16656 17.5554H11.3888C12.6161 17.5554 13.611 16.5605 13.611 15.3332V14.2221H15.8332C17.0605 14.2221 18.0554 13.2272 18.0554 11.9999V8.66656C18.0554 7.43926 17.0605 6.44434 15.8332 6.44434H13.611ZM13.611 13.111H15.8332C16.4469 13.111 16.9443 12.6135 16.9443 11.9999V8.66656C16.9443 8.05291 16.4469 7.55545 15.8332 7.55545H13.611C12.9974 7.55545 12.4999 8.05291 12.4999 8.66656V10.075C13.1641 10.4592 13.611 11.1774 13.611 11.9999V13.111ZM8.05545 11.9999C8.05545 11.3862 8.55291 10.8888 9.16656 10.8888H11.3888C12.0024 10.8888 12.4999 11.3862 12.4999 11.9999V15.3332C12.4999 15.9469 12.0024 16.4443 11.3888 16.4443H9.16656C8.55291 16.4443 8.05545 15.9469 8.05545 15.3332V11.9999Z",
    fill: "#667185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.390c80c202f791fc2cc8ff68cd725b14.svg";
export { ForwardRef as ReactComponent };